export const row_sizes = { noc: 5, package: 5, requests: 5 };
export const grid_indices = { noc: 0, package: 0, requests: 0 };
export const categories = ["noc", "package", "requests"];
export const notificationLabels = [
  { noc: "NOC Tracker" },
  // { package: "Permit Packages" },
  // { requests: "Notarization Requests" },
];
